import { gsap } from "gsap";
export default () => {
	const headerSub = document.querySelector('.header-submenu');
	const headerSubNav = document.querySelectorAll('.header-submenu ul');

	if (headerSub) {
		headerSubNav.forEach((item) => {
			if (item.querySelectorAll('li').length < 4) {
				item.style.justifyContent = 'space-around';
			}
		});
	}

    const openMobMenu = document.querySelector('.mobile-menu__open');
    const closeMobMenu = document.querySelector('.mobile-menu__close');
    const mobMenu = document.querySelector('.mobile-menu');
    const openSubmenus = document.querySelectorAll('.header-nav__item [data-open]');
    const navItems = document.querySelectorAll('.header-nav__item');
    const submenus = document.querySelectorAll('[data-submenu]');
    if (openMobMenu) {
        mobMenu.style.left = '-100%';

        openMobMenu.addEventListener('click', (e) => {
            e.preventDefault();
            mobMenu.style.left = '0';
        })
        closeMobMenu.addEventListener('click', (e) => {
            e.preventDefault();
            mobMenu.style.left = '-100%';
        })
    }
    navItems.forEach(btn =>{
        const link = btn.querySelector('.header-nav__item-link');
        const submenu = document.querySelector(`[data-submenu="${btn.dataset.open}"]`);
        const showSubmenu = (btn)=>{
            gsap.to(submenu, {
                height:'auto',
                duration: 0.5,
                onStart: ()=>{btn.classList.add('active'); link.classList.add('active')}
            })
        }
        const hideSubmenu = (btn)=>{
            gsap.to(submenu, {
                height: 0,
                duration: 0.5,
                onStart: ()=>{btn.classList.remove('active'); link.classList.remove('active')}
            })
        }
        if (window.innerWidth< 1025) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                showSubmenu(btn);
            });

            window.addEventListener('click', (e) => {
                if (link.classList.contains('active') &&
                    e.target !== btn && e.target.closest('.header-nav__item') !== btn) {
                    hideSubmenu(btn);
                }
            })
            // for no-touch
        } else {

            window.addEventListener('mouseover', function(e) {
                if (link.classList.contains('active')) {
                    if (e.target !== link && e.target.closest('.header-nav__item') !== btn) {
                        hideSubmenu(btn);
                    }
                } else {
                    if (e.target === link) {
                        showSubmenu(btn);
                    }
                }
            });
        }


    })
    // openSubmenus.forEach(el =>{
    //     const submenu = document.querySelector(`[data-submenu="${el.dataset.open}"]`);
    //     el.addEventListener('mouseover', (e) =>{
            

    //             gsap.to(submenu, {
    //                 height:'auto',
    //                 duration: 0.5,
    //                 onStart: ()=>{el.classList.add('active');}
    //             })
    //     })
    //     el.addEventListener('mouseout', (e) =>{
            

    //         gsap.to(submenu, {
    //             height: 0,
    //             duration: 0.5,
    //             onComplete: ()=>{el.classList.remove('active');}
    //         })
            
    //     })
    // })
};
